<div class="checkbox-container" [ngClass]="getValidationNgClasses()">
  <div class="checkbox-label-group">
    <p-checkbox
      [binary]="true"
      [(ngModel)]="value"
      [disabled]="disabled"
      [id]="id"
      (ngModelChange)="onValueChange($event)">
    </p-checkbox>

    <ng-container *ngIf="label">
      <label [for]="id">{{ label }}</label>
    </ng-container>
    <ng-content></ng-content>
  </div>

  @if (control?.invalid && (control?.dirty || control?.touched)) {
    <div class="error-messages">
      @for (message of errorMessages; track $index) {
        <small class="error-message">{{ message }}</small>
      }
    </div>
  }
</div>
